import { FunctionComponent } from 'react';
import { InternalEventLinkProps } from '../types';

export const InternalEventLink: FunctionComponent<InternalEventLinkProps> = ({ text, onClickEvent }) => (
  // Button should be used instead of a Anchor tag for accessibility reasons
  // because it is not a link to another page
  <button
    type="button"
    className="tou-modal_link"
    onClick={onClickEvent}
  >
    {text}
  </button>
);
